const ITEMS = [
  "New arrivals",
  "Wholesale prices",
  "Pickup today in store",
  "Ships to you",
  "Free local delivery $299+",
  "New inventory every week",
  "Grand Rapids, MI",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="bg-[#0A1E5E] border-b-2 border-[#F0B90B]/40 overflow-hidden py-2.5" data-testid="marquee-ticker">
      <div className="marquee-track">
        {row.map((t, i) => (
          <span
            key={i}
            className="flex items-center shrink-0 text-[11px] font-black tracking-[0.3em] uppercase text-white/90"
          >
            <span className="px-5">{t}</span>
            <span className="text-[#F0B90B]">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
}
